import { apiClient } from "@copro/api";

// Deletes the given files from Google Drive, ignoring anything that isn't a
// Drive-hosted URL (e.g. manually pasted links). Best-effort by design: callers
// use it as cleanup around a DB mutation and should not let it block the write.
export async function deleteDriveFiles(fileUrls: (string | null | undefined)[], spaceId: string) {
  const driveUrls = fileUrls.filter(
    (url): url is string => !!url && url.includes('drive.google.com')
  );

  if (driveUrls.length === 0) return;

  const { error } = await apiClient
    .functions
    .invoke('delete-from-drive', {
      body: { fileUrls: driveUrls, spaceId },
    });

  if (error) {
    throw error;
  }
}

// Same as deleteDriveFiles but never throws: for cleanup around a DB write that
// must succeed even if Drive is disconnected or the file is already gone. A
// failed cleanup leaves an orphan file, which is preferable to blocking the write.
export async function deleteDriveFilesQuietly(fileUrls: (string | null | undefined)[], spaceId: string) {
  try {
    await deleteDriveFiles(fileUrls, spaceId);
  } catch {
    // Ignore: Drive cleanup is best-effort.
  }
}
